import * as React from 'react'

const VerifiedTickIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.003 10.8a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6Zm2.224-5.576a.6.6 0 0 0-.848-.848L5.403 6.35l-.776-.775a.6.6 0 1 0-.848.848l1.2 1.2a.6.6 0 0 0 .848 0l2.4-2.4Z"
      fill={props.fill}
    />
  </svg>
)

VerifiedTickIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#059669'
}

export { VerifiedTickIcon }
